export default __webpack_public_path__ + "static/media/google-share-2-en.3525cf85.jpeg";